// @flow
import React from 'react'
import { connect } from 'react-redux'
import formatters from 'lib/formatters'
import { Link } from 'react-router-dom'
import { Table, Row, Cell } from 'components/Table'
import Ref from 'components/References/Ref'
import { SUBACCOUNT_TYPES } from 'lib/constants'
import styles from './styles.css'
import { setModal } from 'lib/modal/actions'
import AddSubaccountModal from './AddSubaccountModal'

type Subaccount = {
  balance: number,
  number: string,
  subaccount_type: string,
}

type Props = {
  accountNumber: string,
  subaccounts: [Subaccount],
  dispatch: Function,
  collapse?: boolean,
}

export const BalanceRef = (props: Props) => {
  let dataRows = []
  const { accountNumber, subaccounts, dispatch } = props

  const renderSubaccountLink = (subaccount_type, number) => {
    var link
    if (['home', 'individual_investment', 'land', 'mortgage', 'msa', 'vehicle'].includes(subaccount_type)) {
      link = <Link to={`/accounts/${accountNumber}/subaccounts/${number}`}>{number}</Link>
    } else {
      link = <Link to={`/accounts/${number}`}>{number}</Link>
    }
    return link
  }

  const handleAddSubaccountClick = () => {
    dispatch(setModal(<AddSubaccountModal accountNumber={accountNumber} />))
  }

  subaccounts.map((subaccount, idx) => {
    const { balance, number, subaccount_type } = subaccount
    const subaccount_title = SUBACCOUNT_TYPES[subaccount_type]
    dataRows.push(
      <Row key={`subaccount${idx}`}>
        <Cell value={renderSubaccountLink(subaccount_type, number)} accountNumber={accountNumber} number={number} />
        <Cell value={subaccount_title} />
        <Cell value={formatters.money(balance)} mono={true} />
      </Row>,
    )
  })

  let noResults = dataRows.length ? null : 'No subaccounts'
  const headers = [{ value: 'Number' }, { value: 'Type' }, { value: 'Balance', type: 'mono' }]

  const addSubaccountButton = (
    <button onClick={handleAddSubaccountClick} className={styles.addSubaccountButton}>
      <span className={styles.addSubaccountIcon}>+</span>
      Add Subaccount
    </button>
  )

  return (
    <Ref
      title={
        <div className={styles.balanceRefHeader}>
          <span>Account Balances</span>
          {addSubaccountButton}
        </div>
      }
      preview={
        <Table headers={headers} tableSize="large" tableType="read" noResults={noResults}>
          {dataRows}
        </Table>
      }
      details={false}
      collapse={props.collapse}
    />
  )
}

export default connect()(BalanceRef)
